import type { IconGlyph } from '../icon';

/**
 * Tractie `check` glyph (extra small, 16×16).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/xs/check.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconCheckXs: IconGlyph = {
  name: 'check-xs',
  path: 'M12.83 4.12a.49.49 0 0 0-.7.05l-5.65 6.59-2.62-2.62c-.2-.2-.51-.2-.71 0s-.2.51 0 .71l3.38 3.38 6.35-7.41c.18-.21.16-.53-.05-.71Z',
  viewBox: 16,
};
